<div class="container-fluid pb-3 d-flex flex-column h-100">
  <div class="row">
    <div class="col-12">
      <h2>Add Client</h2>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <app-add-edit-client></app-add-edit-client>
    </div>
  </div>
</div>
